import { TSupportedIntroducerTypes } from 'lendingApi/lendingApi.types';

export const IWOCAPAY_ACCOUNTANTS_URL =
  'https://uploads-ssl.webflow.com/62b040bf442187a12361b14f/66a35aeb9a3972788b70a904_iwoca_iwocaPay_Accountants_Mar-2023.pdf';

export const IWOCAPAY_BROKERS_URL =
  'https://static.iwoca.com/pdf/iwoca_iwocaPay_Brokers_Mar-2023.pdf';

export const UNLOCK_URLS = {
  credit_facility: {
    accountant: 'https://share.hsforms.com/1Jqq_43vXTHKUrf4FMZg99Q3rrot',
    broker: 'https://share.hsforms.com/1O0ylpCL2RqCdH2EPYUFm_Q3rrot',
    sales: '',
    iwoca_sales: '',
    partner: '',
  },
  iwocaPay: {
    accountant: 'https://share.hsforms.com/1yzBiEQ5ATj-Ej5ISflQgxA3rrot',
    broker: 'https://share.hsforms.com/1pnpn4NIxQu6PORTocWwMIw3rrot',
    sales: '',
    iwoca_sales: '',
    partner: '',
  },
};

export function getUnlockURL(
  productType: 'credit_facility' | 'iwocaPay',
  introducerType: TSupportedIntroducerTypes = 'broker',
): string {
  if (introducerType === 'other') {
    return UNLOCK_URLS[productType]['broker'];
  }

  return UNLOCK_URLS[productType][introducerType];
}
